import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';

// Marketing Pages
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';

// Clinic Portal
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CreateCase from './pages/CreateCase';
import CaseDetail from './pages/CaseDetail';

// Owner Portal
import OwnerLogin from './pages/OwnerLogin';
import OwnerDashboard from './pages/OwnerDashboard';
import OwnerPetDetail from './pages/OwnerPetDetail';

// NFC Claim
import NFCClaim from './pages/NFCClaim';

import '@/App.css';

function PrivateRoute({ children, role }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Cargando...</p>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to={role === 'owner' ? '/owner/login' : '/clinic/login'} />;
  }
  
  if (role && user.role !== role) {
    return <Navigate to={user.role === 'owner' ? '/owner' : '/clinic/dashboard'} />;
  }
  
  return children;
}

function AppContent() {
  return (
    <div className="App">
      <Routes>
        {/* Public Marketing Pages */}
        <Route path="/" element={<><Navbar /><Home /></>} />
        <Route path="/how-it-works" element={<><Navbar /><HowItWorks /></>} />
        <Route path="/pricing" element={<><Navbar /><Pricing /></>} />
        <Route path="/contact" element={<><Navbar /><Contact /></>} />
        
        {/* Clinic Portal */}
        <Route path="/clinic/login" element={<><Navbar /><Login /></>} />
        <Route
          path="/clinic/dashboard"
          element={
            <PrivateRoute role="clinic_staff">
              <Navbar />
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/clinic/cases/new"
          element={
            <PrivateRoute role="clinic_staff">
              <Navbar />
              <CreateCase />
            </PrivateRoute>
          }
        />
        <Route
          path="/clinic/cases/:id"
          element={
            <PrivateRoute role="clinic_staff">
              <Navbar />
              <CaseDetail />
            </PrivateRoute>
          }
        />
        
        {/* Owner Portal */}
        <Route path="/owner/login" element={<OwnerLogin />} />
        <Route
          path="/owner"
          element={
            <PrivateRoute role="owner">
              <Navbar />
              <OwnerDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/owner/pets/:petId"
          element={
            <PrivateRoute role="owner">
              <Navbar />
              <OwnerPetDetail />
            </PrivateRoute>
          }
        />
        
        {/* NFC Claim - Public */}
        <Route path="/nfc/:token" element={<NFCClaim />} />
        
        {/* Redirects for old routes */}
        <Route path="/login" element={<Navigate to="/clinic/login" replace />} />
        <Route path="/dashboard" element={<Navigate to="/clinic/dashboard" replace />} />
      </Routes>
      <Toaster position="top-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
